import { MARQUEE_ITEMS } from "@/data/content";
import { scrollToId } from "@/lib/scroll";
import { useBooking } from "@/lib/booking";
import { Logo } from "./Navbar";

const COLS = [
  {
    title: "Clinic",
    links: [
      { label: "About", id: "about" }, { label: "Doctors", id: "doctors" },
      { label: "Services", id: "dental" }, { label: "Clinics", id: "clinics" },
      { label: "Testimonials", id: "testimonials" }, { label: "FAQ", id: "faq" },
    ],
  },
  {
    title: "Patients",
    links: [
      { label: "Book Appointment", action: "book" }, { label: "Dental Care", id: "dental" },
      { label: "Skin Care", id: "skin" }, { label: "Contact", id: "contact" },
    ],
  },
  {
    title: "Franchise",
    links: [
      { label: "Why Dyntra", id: "why" }, { label: "Franchise Model", id: "franchise" },
      { label: "Franchise Benefits", id: "franchise" }, { label: "Apply Now", id: "franchise-form" },
    ],
  },
  {
    title: "Dyntra Ecosystem",
    links: [
      { label: "Dyntra Store", href: "https://dyntra.store" }, { label: "Franchise Network", id: "ecosystem" },
    ],
  },
];

export function Footer() {
  const { openBooking } = useBooking();
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <footer data-testid="footer" className="bg-pine-deep text-ivory">
      <div className="overflow-hidden border-y border-gold/20 py-5 select-none" aria-hidden="true">
        <div className="flex w-max animate-marquee gap-10">
          {items.map((item, i) => (
            <span key={i} className="flex items-center gap-10 whitespace-nowrap">
              <span className="font-display text-xl md:text-2xl italic text-ivory/80">{item}</span>
              <span className="h-1.5 w-1.5 rotate-45 bg-gold" />
            </span>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 py-16 md:py-20">
        <div className="grid md:grid-cols-2 lg:grid-cols-6 gap-12">
          <div className="lg:col-span-2">
            <Logo dark />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-ivory/60">
              Dental &amp; Skin Care Clinics — a growing franchise network powered by the Dyntra Store ecosystem.
            </p>
            <p className="mt-3 text-xs font-semibold text-ivory/45">
              A unit of DyntraStore Pvt. Ltd.
            </p>
            <p className="mt-4 text-xs text-gold font-bold uppercase tracking-[0.25em]">
              Smile Better · Look Better · Live Better
            </p>
          </div>
          {COLS.map((col) => (
            <div key={col.title}>
              <p className="text-[11px] uppercase tracking-[0.25em] font-bold text-gold">{col.title}</p>
              <ul className="mt-5 space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    {l.href ? (
                      <a data-testid={`footer-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} href={l.href} target="_blank" rel="noopener noreferrer" className="text-sm text-ivory/65 hover:text-gold transition-colors">
                        {l.label}
                      </a>
                    ) : (
                      <button
                        data-testid={`footer-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                        onClick={() => (l.action === "book" ? openBooking() : scrollToId(l.id))}
                        className="text-sm text-ivory/65 hover:text-gold transition-colors"
                      >
                        {l.label}
                      </button>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 flex flex-col md:flex-row items-center justify-between gap-4 border-t border-ivory/10 pt-8">
          <p className="text-xs text-ivory/50">© 2026 Dyntra Clinics · A unit of DyntraStore Pvt. Ltd. All Rights Reserved.</p>
          <div className="flex items-center gap-6 text-xs text-ivory/50">
            <span data-testid="footer-privacy" className="hover:text-gold transition-colors cursor-pointer">Privacy Policy</span>
            <span data-testid="footer-terms" className="hover:text-gold transition-colors cursor-pointer">Terms &amp; Conditions</span>
            <span data-testid="footer-disclaimer" className="hover:text-gold transition-colors cursor-pointer">Disclaimer</span>
          </div>
          <p className="text-[10px] text-ivory/30">Map data: simplemaps.com</p>
        </div>
      </div>
    </footer>
  );
}
